import { Caption } from '@dashboard/models';
import * as banner from '@dashboard/enums';

export const icons = [banner.Icon.Party, banner.Icon.Money, banner.Icon.Dollar];

export const phrases = [banner.Phrase.NiceWork, banner.Phrase.Horray, banner.Phrase.GreatJob];

export const takeHomePay = banner.Phrase.TakeHomePay;

export const randomNumToThree = Math.floor(Math.random() * 3);

export const emptyCaption: Caption = {
  amount: null,
  date: null,
  icon: null,
  prefix: null,
};

export const ordinalRules: Record<string, any> = new Intl.PluralRules('en', {
  type: 'ordinal',
});

export const suffixes: Record<string, string> = {
  one: 'st',
  two: 'nd',
  few: 'rd',
  other: 'th',
};

export const caption = { icons, ordinalRules, phrases, takeHomePay, suffixes };
